<template>
  <Card class="mt-1" :padding="4">
    <Carousel autoplay loop :autoplay-speed="3000" arrow="always">
      <CarouselItem v-for="item in this.AD_LIST" :key="item.AD_CODE">
        <div class="carousel-item">
          <!--:href="data.IS_NOAD ? '#' : item.AD_LINK"-->
          <a
            @click="reqadlog(item.AD_IMG_URL,item.AD_LINK)"><img :src="item.AD_IMG_URL" alt=""
          /></a> 
        </div>
      </CarouselItem>
    </Carousel>
  </Card>
</template>

<script>
import qs from "qs";
import { getToken } from "@/assets/js/Util";
export default {
  props: ["data"],
  data() {
    return {
      AD_LIST: [], //JSON.parse(window.localStorage.getItem("adlist")) || [],
    };
  },
  mounted() {
    this.getadlist();
  },
  methods: {
    reqadlog(imgurl,adlink) {
      //添加点击广告LOG记录
      console.log('点击广告...');
      let sono = this.data.SO_NO;
      let isad = this.data.IS_NOAD; //是否有广告
      console.log('isnoAd',sono,isad);
      if (isad === false) {
        getToken((token) => {
          this.$http
            .post(
              process.env.VUE_APP_API,
              qs.stringify({
                type: "so_click_ad",
                data: JSON.stringify({
                  so_no: sono,
                  ad_img_url: imgurl,
                }),
                token,
              })
            )
            .then((resp) => {})
            .catch((err) => {
              this.$Message.error({ content: err });
            });
        });
        console.log('adurl',adlink);
        window.location.href=adlink;
      }else{
        console.log('屏蔽广告...');
      }
    },
    getadlist() {
      //let sono = this.data.SO_NO;
      //console.log('soNo',sono);
      getToken((token) => {
        this.$http
          .get(process.env.VUE_APP_API, {
            params: {
              type: "get_ad_list",
              token,
            },
          })
          .then((resp) => {
            console.log("adlist", resp);
            if (resp.data.CODE == "OK") {
              this.AD_LIST = resp.data.AD_LIST;
            }
            //window.localStorage.setItem("adlist", JSON.stringify(this.AD_LIST));
          })
          .catch((err) => {
            this.$Message.error({ content: err });
          });
      });
    },
  },
};
</script>

<style lang="scss" >
.carousel-item {
  img {
    width: 100%;
  }
}
</style>
